export default "__VITE_ASSET__CcIyQIL6__"